import {
  USERTYPEHISTORY_CREATE, USERTYPEHISTORY_CREATE_SUCCESS, USERTYPEHISTORY_CREATE_FAILURE,
  USERTYPEHISTORY_ALL_UPDATE, USERTYPEHISTORY_ALL_UPDATE_SUCCESS, USERTYPEHISTORY_ALL_UPDATE_FAILURE,
  USERTYPEHISTORY_CANCEL, USERTYPEHISTORY_CANCEL_SUCCESS, USERTYPEHISTORY_CANCEL_FAILURE
} from './mutation-types'
import constant from '../constant'

export default {
  state: {
    usertypeHistoryNotify: null
  },
  getters: {
    usertypeHistoryNotify: state => {
      return state.usertypeHistoryNotify
    }
  },
  actions: {
    [USERTYPEHISTORY_CREATE] ({dispatch, state, commit}, params) {
      var data = {}
      if (params) {
        data = params.data
      }
      dispatch('apiPost', {url: '/master/usertype_histories/', data: data, loadparams: 'block'})
        .then(res => {
          if (res.status === 200 || res.status === 304) {
            if (res.data.error) {
              commit(USERTYPEHISTORY_CREATE_FAILURE, res.data)
            } else {
              commit(USERTYPEHISTORY_CREATE_SUCCESS, { data: res.data, callback: params.callback })
            }
          }
        })
        .catch(error => {
          throw error
        })
    },
    [USERTYPEHISTORY_ALL_UPDATE] ({dispatch, state, commit}, params) {
      var data = {}
      if (params) {
        data = params.data
      }
      dispatch('apiPost', {url: '/master/usertype_histories/all_update', data: data, loadparams: 'block'})
        .then(res => {
          if (res.status === 200 || res.status === 304) {
            if (res.data.error) {
              commit(USERTYPEHISTORY_ALL_UPDATE_FAILURE, res.data)
            } else {
              commit(USERTYPEHISTORY_ALL_UPDATE_SUCCESS, { data: res.data, callback: params.callback })
            }
          }
        })
        .catch(error => {
          throw error
        })
    },
    [USERTYPEHISTORY_CANCEL] ({dispatch, state, commit}, params) {
      var data = {}
      if (params) {
        data = params.data
      }
      dispatch('apiPost', {url: '/master/usertype_histories/cancel', data: data})
      .then(res => {
        if (res.status === 200 || res.status === 304) {
          if (res.data.error) {
            commit(USERTYPEHISTORY_CANCEL_FAILURE, res.data)
          } else {
            commit(USERTYPEHISTORY_CANCEL_SUCCESS, { data: res.data, callback: params.callback })
          }
        }
      })
      .catch(error => {
        throw error
      })
    }
  },
  mutations: {
    [USERTYPEHISTORY_CREATE_SUCCESS] (state, data) {
      console.log('USERTYPEHISTORY_CREATE_SUCCESS')
      data.callback()
    },
    [USERTYPEHISTORY_CREATE_FAILURE] (state, data) {
      console.log('USERTYPEHISTORY_CREATE_FAILURE')
      state.usertypeHistoryNotify = {
        danger: true,
        errors: data.error.split(',')
      }
      setTimeout(() => {
        state.usertypeHistoryNotify = null
      }, constant.notifyShowTime.long)
    },
    [USERTYPEHISTORY_ALL_UPDATE_SUCCESS] (state, data) {
      console.log('USERTYPEHISTORY_ALL_UPDATE_SUCCESS')
      data.callback()
    },
    [USERTYPEHISTORY_ALL_UPDATE_FAILURE] (state, data) {
      console.log('USERTYPEHISTORY_ALL_UPDATE_FAILURE')
      state.usertypeHistoryNotify = {
        danger: true,
        errors: data.error.split(',')
      }
      setTimeout(() => {
        state.usertypeHistoryNotify = null
      }, constant.notifyShowTime.long)
    },
    [USERTYPEHISTORY_CANCEL_SUCCESS] (state, data) {
      console.log('USERTYPEHISTORY_CANCEL_SUCCESS')
      if (data.data.already_delete && data.callback) {
        data.callback()
      } else {
        window.location.reload(false)
      }
    },
    [USERTYPEHISTORY_CANCEL_FAILURE] (state, data) {
      console.log('USERTYPEHISTORY_CANCEL_FAILURE')
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/usertypehistory-edit.js